import { motion } from "framer-motion";
import { benchmarks, globalSchools } from "@/data";

export default function Benchmarks() {
  return (
    <div className="py-12 px-4">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold text-primary uppercase tracking-widest mb-2">World-Class Standards</p>
          <h1 className="text-4xl font-bold text-foreground mb-3">Global Benchmarking</h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            GBSRC's pedagogical ecosystem aligns with — and in several dimensions transcends — globally accepted standards in management education.
          </p>
        </div>

        {/* School alignment cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {globalSchools.map((s, i) => (
            <motion.div
              key={s.school}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-primary rounded-xl p-5"
            >
              <p className="font-bold text-white mb-1">{s.school}</p>
              <p className="text-white/60 text-xs mb-3">{s.focus}</p>
              <div className="h-0.5 bg-white/20 rounded" />
              <p className="text-white/40 text-xs mt-3">GBSRC Aligned</p>
            </motion.div>
          ))}
        </div>

        {/* Full benchmark table */}
        <div>
          <h2 className="text-xl font-bold text-foreground mb-4">15-Point Global Practice Alignment</h2>
          <div className="overflow-hidden border border-border rounded-xl">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-primary text-primary-foreground">
                  <th className="text-left p-4 font-semibold w-2/5">#&nbsp;&nbsp;Global Best Practice</th>
                  <th className="text-left p-4 font-semibold w-3/5">GBSRC Implementation</th>
                </tr>
              </thead>
              <tbody>
                {benchmarks.map((row, i) => (
                  <motion.tr
                    key={row.practice}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.03 }}
                    className={i % 2 === 0 ? "bg-background" : "bg-muted/30"}
                  >
                    <td className="p-4 border-b border-border font-semibold text-primary">
                      <span className="text-muted-foreground font-mono text-xs mr-2">{String(i + 1).padStart(2, "0")}</span>
                      {row.practice}
                    </td>
                    <td className="p-4 border-b border-border text-foreground/70">{row.impl}</td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Accreditation strip */}
        <div className="mt-10 bg-muted/40 border border-border rounded-xl p-6 text-center">
          <p className="text-sm font-semibold text-foreground mb-4">Accreditation Framework Alignment</p>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { label: "AACSB", desc: "Assurance of Learning Standards 4 & 5" },
              { label: "EFMD", desc: "Quality Improvement System" },
              { label: "EQUIS", desc: "Internationalisation & Industry Links" },
              { label: "NEP 2020", desc: "Multidisciplinary & Flexible Learning" },
              { label: "OBE", desc: "CO-PO-PSO Graduate Attribute Mapping" },
            ].map((a) => (
              <div key={a.label} className="bg-background border border-primary/30 rounded-lg px-4 py-3 text-left min-w-[160px]">
                <p className="font-bold text-primary text-sm">{a.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
